import {
  alias, params, string, extend, arrayOf, shape, bool, number, customType, client
} from '@thd-nucleus/data-sources';
import { CONSTANTS } from '../utils/constants';

const { API_ENDPOINT } = CONSTANTS;

const refinement = shape({
  label: string(),
  refinementKey: string()
});

const dimension = shape({
  label: string(),
  dimensionId: string(),
  refinements: arrayOf(refinement)
});

export const smartFilterDataModel = {
  [API_ENDPOINT]: params({
    categoryId: string().isRequired(),
    categoryName: string(),
    categoryTaxonomy: string().isRequired(),
    userId: string().isRequired(),
    freeText: string().isRequired(),
  }).shape({
    dimensions: arrayOf(dimension),
    freeText: string(),
    categoryId: string(),
    categoryTaxonomy: string(),
    requestId: string(),
    processingTimeMs: number(),
    errorMessage: string(),
    errorCode: string(),
  })
};
